/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FinchPayGroupBehavior {
  DEFAULT = 'DEFAULT',
  SINGLE_PAY_GROUP = 'SINGLE_PAY_GROUP',
  ESTIMATE_MULTI_PAY_GROUP = 'ESTIMATE_MULTI_PAY_GROUP',
}
